<template>
  <v-container>
    <v-row no-gutters justify="center" align="center" style="margin-top: 150px">
      <v-col cols="12" align="center">
        <router-link to="/">
          <v-img :src="logo" width="97" height="60" />
        </router-link>
      </v-col>
    </v-row>

    <v-row no-gutters justify="center" align="center" style="margin-top: 50px">
      <v-col v-if="this.result === 'success'" cols="12" align="center">
        <span class="title">{{ msgTitle }}</span>
      </v-col>
      <v-col cols="12" align="center" style="margin-top: 10px">
        <span v-html="msgContent" class="content"></span>
        <!-- <div class="content" v-html="msgContent" /> -->
      </v-col>
    </v-row>

    <v-row no-gutters justify="center" align="center" style="margin-top: 50px">
      <v-col cols="12" align="center">
        <v-btn dark color="rgb(40, 144, 103)" elevation="0" style="border-radius: 15px" @click="moveToWorkspace">
          {{ $t('paymentResultbtnMsg') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import logo from '@/assets/img/tape-logo.png'
// import { chkWsDomain } from '@/services/api'
export default {
  created() {
    this.accessMsg()
  },
  name: 'PaymentResult',
  data() {
    return {
      logo: logo,
      msgTitle: '',
      msgContent: '',
      contentClass: '',
      wsDomain: '',
      result: '',
    }
  },
  methods: {
    accessMsg() {
      let searchParams = new URLSearchParams(new URL(location.href).search)
      this.wsDomain = searchParams.get('wsDomain')
      this.result = searchParams.get('result')
      switch (this.result) {
        case 'success':
          this.msgTitle = this.$t('paymentSuccessfulMsgTitle')
          this.msgContent = this.$t('paymentSuccessfulMsgContent')
          return
        case 'fail':
          this.msgTitle = ''
          this.msgContent = this.$t('general.seriousError')
          return
      }
      return
    },
    moveToWorkspace() {
      location.replace(`https://app.tape.ooo/${this.wsDomain}/my`)
    },
  },
}
</script>
<style scoped>
.title {
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 32px;
  align-items: center;
  text-align: center;
  color: #ffffff;
}
.content {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  align-items: center;
  text-align: center;
  color: #96a7af;
}
</style>
